import {
    WALLET_CONNECT,
} from '../constant/const';

export const setWallet = details => {
    return {
        type: WALLET_CONNECT,
        payload: details
    };
};